import React from 'react';
import { Box, CardMedia, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const CertifiedInspectionWeb = () => (
  <Stack sx={{ px: '75px', py: 2, backgroundColor: 'white' }}>
    <Stack sx={{ flexDirection: 'row' }}>
      <Stack gap={2} width="50%" justifyContent="center" pl={8}>
        <Typography color="#F6851F" fontSize={48} fontWeight={700} lineHeight={1.2} mb={1}>
          FOCUS Certified <br />
          Inspection
        </Typography>
        <Typography fontSize="30px" color="#121212" fontWeight="600" pr={5}>
          Trust, Assurance & Peace of Mind
        </Typography>
        {/* <Box mt={2}>
                <Typography color="#000000" fontSize="20px">
                  ✅ Thorough inspection by{' '}
                  <Typography component="span" fontSize="20px" fontWeight={700}>
                    certified experts
                  </Typography>
                </Typography>
                <Typography color="#000000" fontSize="20px">
                  🔧 Over 130 quality checkpoints
                </Typography>
                <Typography color="#000000" fontSize="20px">
                  🛡️ Complete with warranty assurance
                </Typography>
              </Box>
              <FocusInspectionButtonWeb
                title="Book FOCUS Certified Inspection!"
                subtitle="Fill-up car details with location"
                subTitleColor="#121212"
                onClick={() => console.log('Button clicked')}
              />{' '} */}
      </Stack>
      <Stack width="50%">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/certifiedFocus.webp"
          alt="Certified Focus"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain' }}
        />
      </Stack>
    </Stack>
    <Stack sx={{ flexDirection: 'row' }}>
      <Stack width="50%" backgroundColor="#c8c9c9">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/notePadWeb.webp"
          alt="Note pade"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain' }}
        />
      </Stack>
      <Stack width="50%" justifyContent="center" pl={3}>
        <Stack sx={{ maxWidth: '480px', ml: 4 }} gap={0.5}>
          <Typography color="#121212" fontSize={19} fontWeight={600} lineHeight={0.8} mb={1}>
            FOCUS Motors performs 130+
          </Typography>
          <Typography fontSize="19px" color="#121212" fontWeight="600">
            quality checks on-site,{' '}
          </Typography>
          <Typography fontSize="19px" color="#121212" fontWeight="400">
            providing a detailed report and <br />
            warranty-backed assurance for confident buying.{' '}
          </Typography>
          <Box mt={3}>
            <FocusInspectionButtonWeb
              title="Inspect Your Car Now"
              subtitle="Inspection team will contact you soon."
              subTitleColor="#121212"
              onClick={() => console.log('Button clicked')}
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      // divider={<Divider orientation="vertical" flexItem sx={{ borderColor: "#F1761B" }} />}
      spacing={4}
      py={8}
    >
      <Stack flex={4} borderLeft="2px solid #F8630D" pl={0.5}>
        <Typography fontSize={20} color="#000000">
          Inspection directly at the car’s
          <br /> location
        </Typography>
      </Stack>

      <Stack flex={4} borderLeft="2px solid #F8630D" pl={0.5}>
        <Typography fontSize={20} color="#000000">
          Comprehensive condition report <br />
          provided
        </Typography>
      </Stack>

      <Stack flex={4} borderLeft="2px solid #F8630D" pl={0.5}>
        <Typography fontSize={20} color="#000000">
          Warranty-backed assurance <br />
          from FOCUS Motors
        </Typography>
      </Stack>
    </Stack>
  </Stack>
);

export default CertifiedInspectionWeb;
